import React from 'react';

interface SubLabelProps {
  id: string;
  children: React.ReactNode;
}

export function SubLabel({ id, children }: SubLabelProps) {
  return (
    <label className="mb-3 block text-base italic text-gray-700" htmlFor={id}>
      {children}
    </label>
  );
}
